import axios from 'axios';
import router from '../router';

const state = {
    token: localStorage.getItem('token') || '',
    user: {}, // insercure!! showing too much user data pass ect
    status: '',
    error: null
};

const getters = {
    // isLoggedIn: function(state) {
    //     if (state.token != '') {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
    isLoggedIn: state => !!state.token,
    authState: state => state.status,
    user: state => state.user,
    error: state => state.error
};

const actions = {
    //  Login Action
    async login({commit}, user) {
        commit('auth_request');
        try {
            let res = await axios.post('api/users/login', user);

            if (res.data.success) {
                // console.log(res.data.user);
                const token = res.data.token;
                const user = res.data.user;

                // console.log(user)

                // store the token into the localstorage
                localStorage.setItem('token', token);
                //set the axios defaults
                axios.defaults.headers.common['Authorization'] = token;
                commit('auth_success', token, user);
            }
            
            return res;
        } catch (err) {
            commit('auth_error', err);
        }
    },
    // register user
    // async register({
    //     commit
    // }, userData) {
    //     try {
    //         commit('register_request');
    //         let res = await axios.post('api/users/register', userData);
    //         if (res.data.success !== undefined) {
    //             commit('register_success');
    //         }
    //         return res;
    //     } catch (err) {
    //         commit('register_error', err);
    //     }
    // },
    // get the user profile
    async getProfile({ commit }) {
        // console.log('get profile')
        commit('profile_request');
        let res = await axios.get('api/users/profile');
        // console.log(res)
        commit('user_profile', res.data.user);
        return res;
    },
    // Logout user
    async logout({ commit }) {
        await localStorage.removeItem('token');
        commit('logout');
        delete axios.defaults.headers.common['Authorization'];
        router.push('/');
        return;
    },

};

const mutations = {
    auth_request(state) {
        state.error = null;
        state.status = 'loading';
    },
    auth_success(state, token, user) {
        state.token = token;
        state.user = user;
        state.status = 'success';
        state.error = null;
    },
    auth_error(state, err) {
        state.status = 'error';
        state.error = err.response.data.msg;
    },
    register_request(state) {
        state.error = null;
        state.status = 'loading';
    },
    register_success(state) {
        state.error = null;
        state.status = 'success';
    },
    register_error(state, err) {
        state.status = 'error';
        state.error = err.response.data.msg;
    },
    logout(state) {
        state.error = null;
        state.status = '';
        state.token = '';
        state.user = '';
    },
    profile_request(state) {
        state.status = 'loading';
    },
    user_profile(state, user) {
        state.user = user;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};